/**
 * LandingPageDesktop — desktop-only landing (≥1024px).
 *
 * Rendered via <iframe> pointing to the standalone static HTML file at
 * /homepage-preview-c.html. The HTML file is fully self-contained (fonts,
 * animations, AI search demo, tile-swoop, rotating headline word) and its
 * CTAs use `target="_top"` + `/?signup=1` so clicks pop out of the iframe
 * and land on the SPA which opens the auth modal.
 *
 * Mobile users (<1024px) are served the classic LandingPage.js — this
 * component is only mounted from LandingPage.js's viewport gate.
 */
import React, { useEffect, useRef } from 'react';

export default function LandingPageDesktop() {
    const frameRef = useRef(null);

    useEffect(() => {
        // Set page background to match the landing's cream ground so no flash
        // between iframe load and paint on first navigation.
        const prev = document.body.style.background;
        document.body.style.background = '#F5F3EA';
        document.body.style.margin = '0';
        return () => { document.body.style.background = prev; };
    }, []);

    return (
        <iframe
            ref={frameRef}
            src="/homepage-preview-c.html"
            title="BrainSync"
            data-testid="desktop-landing-frame"
            style={{
                width: '100vw',
                height: '100vh',
                border: 0,
                display: 'block',
                background: '#F5F3EA',
            }}
        />
    );
}
